import React, { useState } from "react";
import "./Tabs.css";

const Competition = () => {
  const [activeTab, setActiveTab] = useState("explanation");

  return (
    <div className="rules-container">
      <h1 className="rules-title">Competition</h1>

      {/* Navigation Tabs */}
      <div className="rules-tabs">
        <button
          className={`tab ${activeTab === "explanation" ? "active" : ""}`}
          onClick={() => setActiveTab("explanation")}
        >
          DEFINITION AND EXPLANATION
        </button>
        <button
          className={`tab ${activeTab === "radar" ? "active" : ""}`}
          onClick={() => setActiveTab("radar")}
        >
          RADAR
        </button>
        <button
          className={`tab ${activeTab === "skill" ? "active" : ""}`}
          onClick={() => setActiveTab("skill")}
        >
          THE SKILL EXAM
        </button>
        <button
          className={`tab ${activeTab === "measurement" ? "active" : ""}`}
          onClick={() => setActiveTab("measurement")}
        >
          RACE TIME MEASUREMENT
        </button>
      </div>

      {/* Content */}
      <div className="rules-content">
        {activeTab === "explanation" && (
          <div className="content">
            <img
              src="./gallery/VLD_9970.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              SERBIAN TROPHY is an offroad competition involving vehicles
              divided into TROPHY and ADVENTURE classes. It rides on the
              inaccessible terrain of Kopaonik Mountain and its surroundings.
              The competition involves driving on the radar, one or more skill
              exams, as well as speed exams. The Tourist class drives in a
              caravan and tracks the events in the competition classes.
            </p>
          </div>
        )}
        {activeTab === "radar" && (
          <div className="content">
            <img
              src="./gallery/VLD_8834.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              Before the start of the competition, each crew will receive a
              radar book with detailed driving directions. Radar contains a
              number of stages or special exams. At the end of each stage or SS,
              there is a judge who seals or signs the vehicle’s passage through
              that stage. Each unfinished stamp carries 5,000 penalty points.
              The radar ride officially ends at 7 pm, which includes the
              departure of the judges from the checkpoint and the return of all
              vehicles to the place where they are provided with accommodation.
            </p>
          </div>
        )}
        {activeTab === "skill" && (
          <div className="content">
            <img
              src="./gallery/VLD_8751.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              The skills exam is marked with signal strips and gates (sectors).
              For each SS participants will receive an additional explanation
              attached to the road-book. Teams that have completed the course
              and have passed all the special exams will enter the placement
              pool. In the event that the teams have not mastered the overall
              course, a team with fewer penalty points is better placed. Also,
              If more teams master the entire course, a team with fewer penalty
              points will be better placed.
            </p>
          </div>
        )}
        {activeTab === "behavior" && (
          <div className="content">
            <img
              src="./gallery/VLD_8776.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              Timekeeping can be done on individual marked stages or on Total
              Time. Total Time represents the total time spent on the route from
              Start to Destination. One penalty point is one second on the SS.
              At Total Time, the time is rounded off to 1 minute. SSs can be
              multiplied by a predetermined weight coefficient.
            </p>
          </div>
        )}
        {activeTab === "measurement" && (
          <div className="content">
            <img
              src="./gallery/VLD_8776.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>signature -5,000</p>
            <p>the rope on the tree -1,000</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Competition;
